<template>
    <div class="empty_box">
        <v-header></v-header>
        <div class="mbx">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item :to="{ path: '/' }" alt="小查线索">首页</el-breadcrumb-item>
                <el-breadcrumb-item><a :href="'/emptyshell?text=' + textStr" alt="查空壳">查空壳</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="empty_tabs_box">
            <div class="tabs_box">
                <div :class="[tabsType == 1?'tabs_item click':'tabs_item']" @click="tabsType = 1">空壳主体</div>
                <div :class="[tabsType == 2?'tabs_item click':'tabs_item']" @click="tabsType = 2">空壳网站</div>
                <div :class="[tabsType == 3?'tabs_item click':'tabs_item']" @click="tabsType = 3">空壳APP</div>
            </div>
            <v-modular-one v-if="tabsType == 1"></v-modular-one>
            <v-modular-twe v-if="tabsType == 2"></v-modular-twe>
            <v-modular-three v-if="tabsType == 3"></v-modular-three>
        </div>
        <div style="width:100%;height:20px"></div>
        <v-footer></v-footer>
    </div>
</template>
<script>
import vHeader from './common/header.vue';
import vFooter from './common/footer.vue'
import vModularOne from './modular/modular_one.vue'
import vModularTwe from './modular/modular_twe.vue'
import vModularThree from './modular/modular_three.vue'
export default {
    data(){
        return{
            tabsType:1,
            textStr:''
        }
    },
    components:{
        vHeader,
        vFooter,
        vModularOne,
        vModularTwe,
        vModularThree
    },
    methods:{
    },
    mounted(){
        this.textStr = this.$route.query.text;
    }
}
</script>
<style lang="scss" scoped>
.empty_box{
    width: 100%;
    height: auto;
    background-color: #F0F2F5;
}

.mbx{
    height: 40px;
    line-height: 40px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    cursor: default;
    @media screen and (max-width: 1400px){
        width: 960px;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
    }
    a{
        cursor: default !important;
    }
}

.empty_tabs_box{
    height: auto;
    margin: 0 auto 0;
    background-color: #fff;
    @media screen and (max-width: 1400px){
        width: 960px;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
    }
    .tabs_box{
        width: 100%;
        height: auto;
        display: flex;
        border-bottom: 2px solid #F7F7F7;
        >div.tabs_item{
            width: 200px;
            height: 60px;
            line-height: 60px;
            font-size: 20px;
            text-align: center;
            cursor: default;
        }
        >div.tabs_item.click{
            color: #1F81F8;
            border-bottom: 2px solid #1F81F8;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/emptyShell.vue